import Typography from '@serko/zui/es/Typography';
import { TypographyProps } from '@serko/zui/es/Typography/Typography';
import React, { FunctionComponent } from 'react';
import pure from 'recompose/pure';

interface OwnProps extends TypographyProps {}

export interface ColumnSecondaryTextProps extends OwnProps {}

const ColumnSecondaryTextBase: FunctionComponent<
  ColumnSecondaryTextProps
> = props => (
  <Typography variant="body1" color="textSecondary" lineClamp {...props} />
);

export const ColumnSecondaryText = pure(ColumnSecondaryTextBase);

ColumnSecondaryText.displayName = 'ColumnSecondaryText';
